/**
 * Resource-free metadata for every language presented by FrontDesk+.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * FRONTDESK_LANGUAGE_CATALOG.find(({ code }) => code === "de")?.label;
 * ```
 */
export const FRONTDESK_LANGUAGE_CATALOG = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "tr", label: "Türkçe" },
  { code: "ru", label: "Русский" },
  { code: "uk", label: "Українська" },
  { code: "ar", label: "العربية" },
  { code: "fa", label: "فارسی / دری" },
  { code: "ps", label: "پښتو" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "pl", label: "Polski" },
  { code: "ro", label: "Română" },
  { code: "bg", label: "Български" },
  { code: "nl", label: "Nederlands" },
  { code: "pt", label: "Português" },
  { code: "hr", label: "Hrvatski" },
  { code: "cs", label: "Čeština" },
  { code: "sk", label: "Slovenčina" },
  { code: "hu", label: "Magyar" },
  { code: "sr", label: "Srpski" },
  { code: "ko", label: "한국어" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
] as const;

/**
 * Language code represented in the complete FrontDesk+ language catalog.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const language: FrontDeskLanguageCode = "en";
 * ```
 */
export type FrontDeskLanguageCode =
  (typeof FRONTDESK_LANGUAGE_CATALOG)[number]["code"];
